import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ProductCart } from 'src/app/models/product-cart';
import { ModalDialogType } from '../constants';
import { PosAddGiftcardModalComponent } from 'src/app/shared/pos-add-giftcard-modal/pos-add-giftcard-modal.component';
import { Order } from 'src/app/models/order';

@Injectable({
  providedIn: 'root'
})
export class PosAddGiftcardModalService {

  private modalRef?: BsModalRef;
  constructor(private modalService: BsModalService) {


  }

  async show(product: ProductCart, order: Order, confirmAction: (product: ProductCart) => any, isEdit: boolean = false): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.modalRef = this.modalService.show(PosAddGiftcardModalComponent, {
        ignoreBackdropClick: true
      });
      this.modalRef.setClass(`modal-dialog ${ModalDialogType.PRIMARY}`)
      this.modalRef.content.productCart = product;
      this.modalRef.content.order = order;
      this.modalRef.content.isEdit = isEdit;
      this.modalRef.content.load();
      this.modalRef.content.confirmAction = confirmAction;

      resolve(true);
    })
  };
}
